import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import provideRenderToLayer from '../hoc/provide-render-to-layer';
export default function provideSnackbar(Target) {
  var ProvideSnackbar = /*#__PURE__*/function (_Component) {
    _inherits(ProvideSnackbar, _Component);

    var _super = _createSuper(ProvideSnackbar);

    function ProvideSnackbar() {
      var _this;

      _classCallCheck(this, ProvideSnackbar);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _this.openSnackbar = function (element) {
        var snackbar = {};

        var close = function close() {
          _this.props.unrenderAtLayer(snackbar.element);
        };

        snackbar.element = _this.props.renderToLayer(element, {
          onRequestClose: close
        });
        snackbar.close = close;
        return snackbar;
      };

      _this.closeSnackbar = function (snackbar) {
        snackbar.close();
      };

      return _this;
    }

    _createClass(ProvideSnackbar, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            renderToLayer = _this$props.renderToLayer,
            unrenderAtLayer = _this$props.unrenderAtLayer,
            props = _objectWithoutProperties(_this$props, ["renderToLayer", "unrenderAtLayer"]);

        return React.createElement(Target, _extends({}, props, {
          openSnackbar: this.openSnackbar,
          closeSnackbar: this.closeSnackbar
        }));
      }
    }]);

    return ProvideSnackbar;
  }(Component);

  ProvideSnackbar.propTypes = process.env.NODE_ENV !== "production" ? {
    renderToLayer: PropTypes.func.isRequired,
    unrenderAtLayer: PropTypes.func.isRequired
  } : {};
  return provideRenderToLayer(ProvideSnackbar);
}